import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-help.svg";
import * as styles from "./Icon.module.scss";

type HelpProps = React.SVGProps<SVGSVGElement>;

export const Help = ({ className, ...props }: HelpProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
